import { render, staticRenderFns } from "./RatingArchive.vue?vue&type=template&id=1f542e8f&scoped=true&"
import script from "./RatingArchive.vue?vue&type=script&lang=js&"
export * from "./RatingArchive.vue?vue&type=script&lang=js&"
import style0 from "./RatingArchive.vue?vue&type=style&index=0&id=1f542e8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f542e8f",
  null
  
)

export default component.exports